/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createEntityDetailsResponseOfOrderFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeEntityDetailsResponseOfOrder, serializeUpdateOrderStatusRequest, type EntityDetailsResponseOfOrder, type ErrorResponse, type InternalErrorResponse, type UpdateOrderStatusRequest } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/{-id}/status
 */
export interface StatusRequestBuilder extends BaseRequestBuilder<StatusRequestBuilder> {
    /**
     * Sets an order's status. The value is not validated against the organization's configured statuses — imported orders legitimately carry statuses the org never registered, and callers such as the order export set their own. The domain trims the value; a blank one is rejected.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<EntityDetailsResponseOfOrder>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateOrderStatusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<EntityDetailsResponseOfOrder | undefined>;
    /**
     * Sets an order's status. The value is not validated against the organization's configured statuses — imported orders legitimately carry statuses the org never registered, and callers such as the order export set their own. The domain trims the value; a blank one is rejected.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateOrderStatusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const StatusRequestBuilderUriTemplate = "{+baseurl}/api/orders/{%2Did}/status";
/**
 * Metadata for all the requests in the request builder.
 */
export const StatusRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: StatusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createEntityDetailsResponseOfOrderFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateOrderStatusRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
